export default "__VITE_ASSET__BNLB_CSQ__"